"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Select2Ui = _interopRequireDefault(require("../Select2Ui"));
var _ItemRow = _interopRequireDefault(require("../selectables/ItemRow"));
var _useSelectOptions = _interopRequireDefault(require("./useSelectOptions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var IconChevronDown = function IconChevronDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconChevronDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  colorOptionSelect: "main",
  colorLabel: "greyLight",
  borderRadius: "4px",
  height: "48px",
  my: "s5",
  keyValue: "id",
  textTransform: "none",
  borderColor: "neutral700",
  bg: "none",
  font: "base_sans",
  pl: "14px",
  valueMarginTop: "14px",
  colorArrow: "main",
  icon: __jsx(IconChevronDown, null),
  mt: 0
};
var SelectInDialog = function SelectInDialog(props) {
  var _ref$current$offsetWi, _ref$current;
  var _props$colorOptionSel = props.colorOptionSelect,
    colorOptionSelect = _props$colorOptionSel === void 0 ? defaultProps.colorOptionSelect : _props$colorOptionSel,
    _props$colorLabel = props.colorLabel,
    colorLabel = _props$colorLabel === void 0 ? defaultProps.colorLabel : _props$colorLabel,
    _props$borderRadius = props.borderRadius,
    borderRadius = _props$borderRadius === void 0 ? defaultProps.borderRadius : _props$borderRadius,
    _props$height = props.height,
    height = _props$height === void 0 ? defaultProps.height : _props$height,
    _props$my = props.my,
    my = _props$my === void 0 ? defaultProps.my : _props$my,
    _props$mb = props.mb,
    mb = _props$mb === void 0 ? defaultProps.mb : _props$mb,
    _props$keyValue = props.keyValue,
    keyValue = _props$keyValue === void 0 ? defaultProps.keyValue : _props$keyValue,
    _props$textTransform = props.textTransform,
    textTransform = _props$textTransform === void 0 ? defaultProps.textTransform : _props$textTransform,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? defaultProps.borderColor : _props$borderColor,
    _props$bg = props.bg,
    bg = _props$bg === void 0 ? defaultProps.bg : _props$bg,
    _props$font = props.font,
    font = _props$font === void 0 ? defaultProps.font : _props$font,
    _props$pl = props.pl,
    pl = _props$pl === void 0 ? defaultProps.pl : _props$pl,
    _props$valueMarginTop = props.valueMarginTop,
    valueMarginTop = _props$valueMarginTop === void 0 ? defaultProps.valueMarginTop : _props$valueMarginTop,
    _props$colorArrow = props.colorArrow,
    colorArrow = _props$colorArrow === void 0 ? defaultProps.colorArrow : _props$colorArrow,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? defaultProps.icon : _props$icon,
    _props$mt = props.mt,
    mt = _props$mt === void 0 ? defaultProps.mt : _props$mt;
  var controller = props.controller || (0, _useSelectOptions["default"])(props);
  var ref = (0, _react.useRef)(null);
  var dataTest = props["data-test"] ? {
    "data-test": props["data-test"]
  } : {};
  return __jsx(_Box["default"], null, __jsx(_Box["default"], (0, _extends2["default"])({
    sx: {
      color: "main",
      font: "text2",
      my: my,
      mb: mb,
      bg: bg,
      border: "1px solid",
      borderColor: borderColor,
      borderRadius: borderRadius,
      height: height,
      position: "relative",
      pl: pl,
      mt: mt
    },
    _ref: ref
  }, dataTest), __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: colorLabel,
      font: "xxs_caps",
      my: "s4",
      position: "absolute",
      textTransform: textTransform
    }
  }, controller.selectProps.label), __jsx(_Select2Ui["default"], (0, _extends2["default"])({}, controller.selectProps, {
    button: function button(_ref) {
      var _value$keyValue;
      var value = _ref.value;
      return __jsx(_Box["default"], {
        sx: {
          width: "100%",
          font: "body2",
          lineHeight: 1,
          minWidth: "100%",
          height: "100%",
          cursor: "pointer",
          color: props.loading ? "neutral" : "black"
        }
      }, __jsx(_Box["default"], {
        sx: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          textAlign: "right",
          width: "100%",
          height: "100%",
          paddingRight: "10px",
          color: colorArrow
        }
      }, __jsx(_Box["default"], {
        sx: {
          color: colorOptionSelect,
          textAlign: "left",
          width: "90%",
          alignItems: "center",
          marginTop: valueMarginTop,
          font: font,
          textTransform: textTransform
        }
      }, (_value$keyValue = value === null || value === void 0 ? void 0 : value[keyValue]) !== null && _value$keyValue !== void 0 ? _value$keyValue : value), icon));
    },
    selectable: __jsx(_ItemRow["default"], {
      textTransform: textTransform
    }),
    allowEmpty: true,
    anchoredTo: ["window", null, ref],
    placement: ["center", null, "bottomLeft"],
    width: (_ref$current$offsetWi = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.offsetWidth) !== null && _ref$current$offsetWi !== void 0 ? _ref$current$offsetWi : ["90vw", null, "20vw"],
    root: {
      height: ["70vh", null, 300],
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
      bg: "white"
    }
  }))));
};
SelectInDialog.labelInside = true;
var _default = SelectInDialog;
exports["default"] = _default;